/** Which kind of market a list shows: everything, spot, futures, or (where there are any) stocks. */
export type MarketTypeChoice = "all" | "spot" | "futures" | "equity";

/** Whether a row of this market type passes the filter. Rows without one are spot. */
export function matchesMarketType(choice: MarketTypeChoice, marketType: string | null | undefined): boolean {
  return choice === "all" || (marketType ?? "spot") === choice;
}
